var product = new Vue({
    el: '#product-quantity',
    delimiters: ['${', '}'],
    data: {
        quantity:1,
    },
    methods: {
        add: function () {
            this.quantity = this.quantity + 1
        },
        reduce:function (){
            if(this.quantity === 1)
            {
                this.quantity = 1
            }else{
                this.quantity = this.quantity -1
            }
        }
    }
})